<template>
  <header>
    <div class="septris-logo"></div>
    <div class="spacer"></div>
<!--    <img class="pause" :src="pauseShown ? require('@/assets/images/icons/play.png') : require('@/assets/images/icons/pause.png')" alt="Pause" @click="togglePause">-->
    <div class="header-divider"></div>
    <img class="menu-button" src="../assets/images/icons/menu.png" alt="Menu" @click="toggleMenu">
<!--    <transition @after-enter="afterAlertOpen" @after-leave="afterAlertClose">-->
    <transition @after-leave="afterAlertClose">
      <div id="alertBar" v-if="showAlert">{{alertQueue[0]}}</div>
    </transition>
  </header>
  <div id="playArea">
    <sidebar></sidebar>
    <patient-info></patient-info>
  </div>
  <buttons></buttons>
  <div class="modal-container" v-if="pauseShown">
    <div class="paused">{{$store.getters['getUIText']('paused')}}</div>
  </div>
  <div class="modal-container" v-if="menuShown">
    <div class="menu">
      <button @click="hideMenu">{{$store.getters['getUIText']('resume')}}</button>
      <div id="gameSpeedWrap">
        <h3>Game Speed</h3>
        <ul id="gameSpeedList">
          <li><label for="gameSpeedSlow"><input type="radio" name="gameSpeed" id="gameSpeedSlow" :checked="gameSpeed === 0.5" @click="setGameSpeed(0.5)"> Slow</label></li>
          <li><label for="gameSpeedNormal"><input type="radio" name="gameSpeed" id="gameSpeedNormal" :checked="gameSpeed === 1" @click="setGameSpeed(1)"> Normal</label></li>
          <li><label for="gameSpeedFast"><input type="radio" name="gameSpeed" id="gameSpeedFast" :checked="gameSpeed === 2" @click="setGameSpeed(2)"> Fast</label></li>
        </ul>
      </div>
<!--      <button v-if="gameSpeed === 1" @click="setGameSpeed(2)">{{$store.getters['getUIText']('increasegamespeed')}}</button>-->
<!--      <button v-if="gameSpeed > 1" @click="setGameSpeed(1)">{{$store.getters['getUIText']('decreasegamespeed')}}</button>-->
      <button @click="exitGame">{{$store.getters['getUIText']('resetgameandreturnt')}}</button>
    </div>
  </div>
  <div id="infoPopup" v-if="infoContent" @click.self="hideInfo">
    <div id="infoContent">
      <div class="close" @click="hideInfo">&times;</div>
      <Markdown :source="infoContent"></Markdown>
    </div>
  </div>
  <tip id="tip" v-if="tipShown" :tip="tipShown"></tip>
  <tutorialtip :header="tutorialTip.header" v-if="tutorialTip" @close="clearTutorialTip">{{tutorialTip.text}}</tutorialtip>
</template>

<script>
import Sidebar from "@/components/sidebar";
import PatientInfo from "@/components/patient-info";
import Buttons from "@/components/buttons";
import tip from "@/components/tip";
import GameManager from "@/assets/js/GameManager";
import {watch} from "vue";
import Tutorialtip from "./tutorialtip";
import Markdown from "vue3-markdown-it";
export default {
  name: "game",
  components: {Tutorialtip, Buttons, PatientInfo, Sidebar, tip, Markdown},
  emits: ['showStart', 'showEnd'],
  data(){
    return {
      pauseShown: false,
      menuShown: false,
      alertQueue: [],
      showAlert: false,
      alertTimer: 0,
    }
  },
  computed: {
    tipShown(){
      return GameManager.tipQueue[0];
    },
    gameOver(){
      return GameManager.game_over;
    },
    gameSpeed(){
      return GameManager.game_speed;
    },
    tutorialTip(){
      return GameManager.tutorialtip;
    },
    infoContent(){
      return GameManager.infoContent;
    }
},
  methods: {
    showPause(){
      this.pauseShown = true;
      GameManager.pauseGame();
    },
    hidePause(){
      this.pauseShown = false;
      GameManager.unpauseGame();
    },
    togglePause(){
      // console.log(GameManager);
      this.pauseShown = !this.pauseShown;
      GameManager.togglePause();
    },
    showMenu(){
      this.menuShown = true;
      GameManager.pauseGame();
    },
    hideMenu(){
      this.menuShown = false;
      GameManager.unpauseGame();
      if(this.showAlert) this.afterAlertOpen();
    },
    toggleMenu(){
      if(this.menuShown) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
    },
    setGameSpeed(speed){
      GameManager.setGameSpeed(speed);
    },
    exitGame(){
      // Router.push("/");
      this.$emit("showStart");
    },
    showNextAlert() {
      console.log("showing alert", this.alertQueue.length)
      if (this.alertQueue.length > 0 && this.showAlert === false && !GameManager.paused) {
        this.showAlert = true;
        this.alertTimer = 3500; // Show alerts for 3.5 seconds
        window.requestAnimationFrame(this.afterAlertOpen);
      }
    },
    afterAlertOpen() {
      if(!GameManager.paused) {
        this.alertTimer -= GameManager.timeDelta
      }
      if(this.alertTimer <= 0){
        this.showAlert = false;
      } else {
        window.requestAnimationFrame(this.afterAlertOpen);
      }
      // window.setTimeout(()=>{
      //   if(!GameManager.paused) this.showAlert = false;
      // }, 3500)

    },
    afterAlertClose() {
      this.alertQueue.shift();
      this.showNextAlert();
    },
    clearTutorialTip(){
      GameManager.showTutorialTip();
    },
    hideInfo(){
      GameManager.hideInfo();
    }
  },
  mounted(){
    //GameManager.StartGame();
    watch([GameManager.alertQueue], () => {
      if(!GameManager.paused && GameManager.alertQueue.length > 0) {
        this.alertQueue.push(GameManager.alertQueue.shift());
        this.showNextAlert();
      }
    }, {immediate: true, deep: true})
  },
  watch: {
    gameOver(newVal){
      console.log("Game Over!", newVal);
      if(newVal){
        if(GameManager.tutorial){
          this.exitGame();
        } else {
          this.$emit('showEnd');
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import (reference) "../assets/less/colors";

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}
.v-enter-from,
 .v-leave-to{
  opacity: 0;
}

header{
  display: flex;
  align-items: center;
  padding: 2px 1.25vw;
  text-align: center;
  background-image: linear-gradient(to bottom, lighten(@lightgray, 20%), @lightgray);
  position: relative;
  z-index: 100;
  .septris-logo{
    height: 50px;
    width: 300px;
    background: url("../assets/images/Septris-sprite-start.png") -0px -3px no-repeat;
  }
  .spacer{
    flex: 1;
  }
  .pause{
    display: block;
    margin: 0 15px;
    cursor: pointer;
  }
  .header-divider{
    background-image: linear-gradient(to top, rgba(125,125,125,0), rgb(124,124,124) 25%, rgb(124,124,124) 75%, rgba(125,125,125,0) 100%);
    height: 35px;
    width: 1px;
    margin-right: 15px;
  }
  .menu-button{
    display: block;
    cursor: pointer;
  }
  #alertBar{
    height: 2em;
    width: 100%;
    position: absolute;
    left: 0;
    top: 100%;
    //background: linear-gradient(top, #b01937, #5c0d1d);
    background: linear-gradient(#b01937, #5c0d1d);
    display: flex;
    justify-content: center;
    align-items: center;
    color: @white;
    font-size: 1.25rem;
    letter-spacing: 0.02em;
  }
}
#playArea{
  width: 100%;
  display: flex;
  height: calc(100vh - 164px);
}

.modal-container{
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 54px;
  left: 0;
  width: 100%;
  height: calc(100vh - 54px);
  background: rgba(0,0,0,0.15);
  z-index: 100;
  // backdrop-filter: blur(5px);
}
.paused{
  font-size: 15vw;
  margin-bottom: 108px;
  font-weight: bold;
  text-shadow: white 0 0 7vh;
}
.menu{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0.5em;
  #gameSpeedWrap{
    width: 100%;
    background: @white;
    padding: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
  }
  h3{
    font-weight: normal;
    margin: 0;
    font-size: 2.7vh
  }
  #gameSpeedList{
    font-size: 2.2vh;
    margin: 1rem 0 0;
    list-style: none;
    padding: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    li{
      margin-right: 1em;
    }
  }
  button{
    min-width: 30vw;
    margin: 0.5em 0;
    font-size: 3vh;
    padding: 0.3em;
  }
}
#infoPopup{
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.15);
  backdrop-filter: blur(5px);
  z-index: 101;
}
#infoContent{
  background: @white;
  padding: 1em;
  max-width: 50%;
  max-height: 80%;
  position: relative;
  .close {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 10px;
    top: 10px;
    width: 1.5rem;
    height: 2rem;
    font-size: 2rem;
    font-weight: bold;
    cursor: pointer;
  }
}

</style>
